<template>
  <div>
    <el-radio-group v-model="trade"
      v-if="status==='select'">
      <el-radio v-if="tradeTypes.indexOf(1) > -1"
        :label="1">进出口</el-radio>
      <el-radio v-if="tradeTypes.indexOf(3) > -1"
        :label="3">内销</el-radio>
    </el-radio-group>
    <span v-else>{{tradeName}}</span>
  </div>
</template>

<script>
export default {
  name: 'trade-radio-box',
  components: {},
  props: {
    status: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data () {
    return {
      tradeTypes: [],
      tradeName: ''
    }
  },
  watch: {
    'option.vendorId': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.fetchData()
        }
      }
    }
  },
  computed: {
    trade: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.tradeName = val === 1 ? '进出口' : '内销'
      }
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('vendor/getvendortradetypes', {
        payload: this.option,
        success: (res) => {
          this.tradeTypes = res.data.tradeTypes
          if (this.tradeTypes.length === 1) {
            this.trade = this.tradeTypes[0]
          }
          this.tradeName = this.trade === 1 ? '进出口' : '内销'
        },
        fail: () => {
          this.tagTypeList = []
          this.tradeName = ''
        }
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
